import React from 'react';
import {View} from 'react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import ListItem from '../ListItem';

import {styles} from './ListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={1}>Readonly</Heading>
      <Spacer size={16} />
      <Text>
        A <Code>{'ListItem'}</Code> with the prop <Code>{'readonly'}</Code> is
        used for list items that are not clickable.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <ListItem
          suffix={<Text>18</Text>}
          label={<Text>Ordering Entities</Text>}
          readonly
        />
      </Gutter>
    </View>
  </>
);
